export const ProductConfig: any = {
	fetchConfig: {
		with_relations: 'categories,tripServiceCatalogItems',
		with_attributes: 'language_contents',
	},
	datasetRoute: '/detail/products/',
	getCallParams(params: any): any{
		let ADT = 1;
		if (params['ADT']){
			ADT = params['ADT'];
		}
		params['ADT'] = ADT;
		return params;
	}
};
